import { Link } from '@calendly/ui/components/link'

export const OnboardingGuideLink = ({ children }) => (
  <Link rel="noopener" target="_blank" href="https://calendly.com/help/how-to-set-up-domain-control">{children}</Link>
)

export const DomainReportHelpCenterLink = ({ children }) => (
  <Link rel="noopener" target="_blank" href="https://calendly.com/help/how-to-view-and-invite-users-from-your-verified-domain">
    {children}
  </Link>
)
